import { render } from "./LegoMenu.vue?vue&type=template&id=bb6e1856"
import script from "./LegoMenu.vue?vue&type=script&lang=js"
export * from "./LegoMenu.vue?vue&type=script&lang=js"

import "./LegoMenu.vue?vue&type=style&index=0&id=bb6e1856&lang=scss"
script.render = render

export default script